import React from "react";
import NotebookWithRun from "./NotebookWithRun";
const WorkFLowMainComp = (props) => {
    return (
        <NotebookWithRun
            Display_code_cells={props.Display_code_cells}
            Display_output_cells={props.Display_output_cells}
            hideOutputBlocks={props.hideOutputBlocks}
            hideCodeBlocks={props.hideCodeBlocks}
        />
    )
}
export default WorkFLowMainComp;